import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';

export const PublicRoute: React.FC = () => {
  const { isAuthenticated, token } = useAuthStore();
  const location = useLocation();

  const hasToken = Boolean(isAuthenticated && token);

  if (hasToken) {
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl') || searchParams.get('redirect');
    const destination = returnUrl || '/conversations';
    return <Navigate to={destination} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
